module.exports = __webpack_public_path__ + "media/images/icons/kebab-3741887011488c2436144ff709fedff1.svg";